import React, { PropTypes } from "react";

import PurchaseController from "../Controllers/PurchaseController";

export default function ProductPurchaseWidget(props) {
    return (<PurchaseController {...props} />);
}

ProductPurchaseWidget.propTypes = {
    props: PropTypes.objectOf(React.PropTypes.shape({
        product: React.PropTypes.shape({}).isRequired,
        quantity: PropTypes.number.isRequired,
    })).isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Widgets/ProductPurchaseWidget.jsx